<template>
  <main class="main-page">
    <HeroPage />

    <FeaturedProject />

    <SobreHome />

    <ServicesHome />

    <ProjectsCard />

    <TeamHome />

    <ContatosHome />
  </main>
</template>

<script setup>
import HeroPage from "@/components/HeroPage.vue"
import FeaturedProject from "@/components/FeaturedProject.vue"
import SobreHome from "@/components/SobreHome.vue"
import ServicesHome from "@/components/ServicesHome.vue"
import ProjectsCard from "@/components/ProjectsCard.vue"
import TeamHome from "@/components/TeamHome.vue"
import ContatosHome from "@/components/ContatosHome.vue"
</script>